import { render, staticRenderFns } from "./TaxonomyUrl.vue?vue&type=template&id=53db7e88&"
import script from "./TaxonomyUrl.vue?vue&type=script&lang=js&"
export * from "./TaxonomyUrl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports